import { cn } from 'lib/utils'
import { Switch as ShadSwitch } from './base/switch'
import { Label } from './label'
import { Typography } from './typography'

export const Switch = ({
  label,
  name,
  onChange,
  value,
  className,
  ...props
}: {
  label?: string | React.ReactNode
  name?: string
  onChange: (checked: boolean) => void
  value: boolean
  className?: string
  disabled?: boolean
  /** Shows a spinner in the thumb and blocks toggling until the value resolves. */
  loading?: boolean
  /** Lets a caller-rendered <Label htmlFor> target the control when no `label` is given. */
  id?: string
}) => (
  <div className={cn('flex items-center', className)}>
    <ShadSwitch
      {...props}
      name={name}
      onCheckedChange={onChange}
      checked={value}
      className="shadow-none"
      onClick={(e) => e.stopPropagation()}
    />
    {label && (
      <Label className="ml-2" htmlFor={name}>
        <Typography variant="P/500" className="text-primary">
          {label}
        </Typography>
      </Label>
    )}
  </div>
)
